import { useEffect, useRef } from "react";

/**
 * Portal visibility only. Becoming visible is not genuine activity
 * and must not auto-resume an AUTO_PAUSED session by itself.
 */
export function useVisibilityDetection({ onVisible, onHidden } = {}) {
  const onVisibleRef = useRef(onVisible);
  const onHiddenRef = useRef(onHidden);
  onVisibleRef.current = onVisible;
  onHiddenRef.current = onHidden;

  useEffect(() => {
    if (typeof document === "undefined") return undefined;

    const handle = () => {
      if (document.visibilityState === "visible") {
        onVisibleRef.current?.();
      } else {
        onHiddenRef.current?.();
      }
    };

    document.addEventListener("visibilitychange", handle);
    return () => document.removeEventListener("visibilitychange", handle);
  }, []);
}
